import { useNavigate } from '@tanstack/react-router';
import { ChevronLeftIcon } from 'lucide-react';

/**
 * The back-button + title bar every legacy screen carries.
 *
 * In the old panel this lives in the shared `LayoutWithTopBar`, and EVERY
 * delivery route passes it a `backText` (see the route files under
 * `src/routes`), so a legacy page without one is missing chrome the original
 * always had.
 *
 * Measured off the live reference at 1440×900: the bar is 52px tall at
 * `x:24, y:30.75`, the circular back button is 40×40 flush at `x:24`, and the
 * title sits at `x:80` — a 16px gap — in 22px/600 (`semi_bold_22`).
 *
 * `backTo` mirrors the old `backUrl` prop: most routes fall back to browser
 * history, but Reports and Staff point explicitly at `/profile`, because they
 * are reached from there rather than from the top nav.
 */
export function LegacyPageHeader({
  title,
  backTo,
}: {
  title: string;
  /** Explicit destination; omitted means "go back one entry in history". */
  backTo?: string;
}) {
  const navigate = useNavigate();

  return (
    <header className="flex h-[52px] items-center gap-4 px-6">
      <button
        type="button"
        aria-label={title}
        onClick={() => {
          if (backTo) {
            void navigate({ to: backTo });
            return;
          }
          globalThis.history.back();
        }}
        className="flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-[var(--lg-surface)] text-[var(--lg-fg)] transition-opacity hover:opacity-80"
      >
        <ChevronLeftIcon className="size-5" />
      </button>
      <h1 className="truncate text-[22px] leading-[25.48px] font-semibold text-[var(--lg-fg)]">
        {title}
      </h1>
    </header>
  );
}
